exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".InfoBox__wrapper___JYHsV {\n    font-weight: 300;\n    color: #777777;\n    margin-bottom: 25px;\n}\n\n.InfoBox__wrapper___JYHsV svg {\n    margin-right: 10px;\n    position: relative;\n    top: 2px;\n}\n\n.InfoBox__label___2DbXR {\n    font-weight: normal;\n    margin-bottom: 0;\n    color: #000000;\n    display: -ms-flexbox;\n    display: flex;\n}\n\nul {\n    padding: 0;\n    list-style: none;\n}\n\n.InfoBox__wrapper___JYHsV a {\n    color: #777777;\n}\n\n.InfoBox__wrapper___JYHsV a:hover {\n    color: #ff8e42;\n}", ""]);

// exports
exports.locals = {
	"wrapper": "InfoBox__wrapper___JYHsV",
	"label": "InfoBox__label___2DbXR"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/InfoBox/InfoBox.css
// module id = 450
// module chunks = 0